(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-stock-status"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const statusElement = document.getElementById('stock-message');
    
    if (!statusElement) {
      return;
    }
    
    const statusTextElement = statusElement.querySelector('.status-text');
    const productForm = document.querySelector('form[action="/cart/add"]');

    if (productForm) {
      const ALL_VARIANT_DATA = JSON.parse(statusElement.dataset.variantJson);

      const stockMessages = {
        green: statusElement.dataset.msgGreen,
        red: statusElement.dataset.msgRed
      };
      
      const getSelectedVariantId = () => {
        const idInput = productForm.querySelector('[name="id"]');
        return idInput ? idInput.value : null;
      };

      const updateStockStatusDisplay = (variantId) => {
        if (!variantId) return;

        const selectedVariantData = ALL_VARIANT_DATA[variantId];
        
        if (!selectedVariantData) return;

        const isAvailable = selectedVariantData.available;
        const metafieldValue = selectedVariantData.metafield;
        const metafieldIsSet = metafieldValue.trim().length > 0;

        let newStatusClass = '';
        let newStatusText = '';

        if (metafieldIsSet) {
          newStatusClass = 'limited-stock';
          newStatusText = metafieldValue;
        } else if (isAvailable) {
          newStatusClass = 'in-stock';
          newStatusText = stockMessages.green;
        } else {
          newStatusClass = 'out-of-stock';
          newStatusText = stockMessages.red;
        }

        statusElement.className = `stock-status-container ${newStatusClass}`;
        statusTextElement.textContent = newStatusText;
      };

      productForm.addEventListener('change', () => {
          setTimeout(() => {
              const newVariantId = getSelectedVariantId();
              if (newVariantId) {
                  updateStockStatusDisplay(newVariantId);
              }
          }, 50); 
      });

      const initialVariantId = getSelectedVariantId();
      if (initialVariantId) {
          updateStockStatusDisplay(initialVariantId);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
